// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
// No current STYLING, but used to TARGET in other COMPONENTS
export const Dimensions = styled.span``
export const DisplayUnit = styled.span``
export const Weight = styled.span``
